import React from 'react'
import { useForm } from 'react-hook-form'
import { Button } from 'reactstrap'
import { Form } from 'react-bootstrap'
import { message } from 'antd'

import { storeCityRouteRate } from '../services'
import { handleError } from '../../../helpers'

export default function NewRateForm({ city_route_id, reload }) {
	const { handleSubmit, register, errors, reset } = useForm()

	const onSubmit = values => {
		storeCityRouteRate({ ...values, city_route_id })
			.then(() => {
				message.success('Tarifa añadida exitosamente')
				reload()
				reset()
			})
			.catch(error => handleError(error))
	}

	return (
		<React.Fragment>
			<Form onSubmit={handleSubmit(onSubmit)} className="mt-1">
				<Form.Group>
					<Form.Label>Valor de Tarifa</Form.Label>
					<Form.Control 
						type="number"
						name="value"
						ref={register({ required: true })}
					/>
					{ errors.value && <Form.Text className="text-warning">Este campo es requerido</Form.Text> }
				</Form.Group>
				<Form.Group>
					<Form.Label>Descripción</Form.Label>
					<Form.Control 
						name="description"
						ref={register({ required: true })}
					/>
					{ errors.description && <Form.Text className="text-warning">Este campo es requerido</Form.Text> }
				</Form.Group>
				<Button color="primary" type="submit">Agregar Tarifa</Button>
			</Form>
		</React.Fragment>
	)
}